import { render, staticRenderFns } from "./GenericTableDateCell.vue?vue&type=template&id=12a5cadf&scoped=true"
import script from "./GenericTableDateCell.vue?vue&type=script&lang=ts"
export * from "./GenericTableDateCell.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a5cadf",
  null
  
)

export default component.exports